import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';

import { RoomType } from '../../shared/room-type.model';
import { RoomTypeDetailComponent } from '../../room-type-detail/room-type-detail.component';

@Component({
  selector: 'app-room-type-modal',
  templateUrl: './room-type-modal.component.html',
  standalone: true,
  imports: [SharedModule, RoomTypeDetailComponent],
})
export class RoomTypeModalComponent {
  constructor(
    private ref: MatDialogRef<RoomTypeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  // @Output() dialogSaved = new EventEmitter<any>(); // avoid closing the dialog

  modalTitle = this.data.title;
  roomType: RoomType = this.data.obj;
  mode = this.data.params.mode;
  defaultLanguage = this.data.params.defaultLanguage;
  additionalLanguages = this.data.params.additionalLanguages;

  // Referenced from app-room-type-detail
  onSavedRoomType(roomType) {
    // this.dialogSaved.emit(roomType); // avoid closing the dialog

    this.ref.close(roomType); // close the dialog
  }

  // Referenced from app-room-type-detail
  onCanceledRoomType() {
    this.close();
  }

  close() {
    this.ref.close();
  }
}
